<div class="modal-content">
  <div class="header">
    <h4 class="titleModal font-weight-bold" id="exampleModalLabel1">
      {{ modal_type }} {{ text.Caso }}
    </h4>
    <mat-icon class="closeModal" [mat-dialog-close]>cancel</mat-icon>
  </div>
  <div class="container">
    <form [formGroup]="form" class="row">
      <mat-form-field appearance="outline" class="col-4">
        <mat-label>Unidad (*)</mat-label>
        <mat-select
          placeholder="Unidad (*)"
          formControlName="unidad"
          name="unidad"
        >
          <mat-option
            *ngFor="let unidad of unidades"
            (click)="changeTipocaso(unidad)"
            [value]="unidad"
          >
            {{ unidad }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-4">
        <mat-label>Tipo de caso (*)</mat-label>
        <mat-select
          placeholder="Tipo de caso (*)"
          [disabled]="form.value.unidad ? false : true"
          formControlName="tipo_caso"
          name="tipo_caso"
        >
          <mat-option *ngFor="let tipo_caso of tipo_casos" [value]="tipo_caso">
            {{ tipo_caso }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        (click)="openDialogSelectUser()"
        appearance="outline"
        class="col-4"
      >
        <mat-label>Asignado A</mat-label>
        <input [disabled]="true" formControlName="asignadoA" matInput />
      </mat-form-field>
      <!-- <ng-container *ngIf="showFormRas">
        <div class="col-12">
          <ras-form [(form)]="formRas"></ras-form>
        </div>
      </ng-container> -->
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>Descripción</mat-label>
        <textarea
          matInput
          placeholder="Describa la tarea..."
          formControlName="descripcion"
        ></textarea>
      </mat-form-field>
      <div class="col-12 mt-4" style="text-align: center">
        <create-case-files [(files)]="files"></create-case-files>
      </div>

      <div class="text-center col-12 mt-4 buttons-content">
        <p style="color: rgb(255, 0, 0)" *ngIf="!canCreate">
          * Complete los campos para crear
        </p>
        <button class="cancel-btn" mat-raised-button [mat-dialog-close]>
          Cancelar
        </button>
        <button
          mat-raised-button
          class="primary-btn"
          [disabled]="submit || !canCreate"
          (click)="crear()"
        >
          {{ modal_type === "Crear" ? "Crear" : "Editar" }}
        </button>
      </div>
    </form>
  </div>
</div>
